import React, { useContext } from "react";
import { FiMessageSquare } from "react-icons/fi"; // Import chat icon
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { AuthContext } from "../../../../Auth/AuthContext";
import classNames from "classnames"; // Import classNames utility for conditional classes
import { styleTotalCoins } from "../../../../Components/Common/CommonFunction";
import { COINS } from "../../../../Constant";
import point from "../../../../../src/assets/images/point.png";
const TotalPoints = () => {
  const navigate = useNavigate(); // Get navigate function from useNavigate
  const { totalPoints } = useContext(AuthContext);

  // Function to handle navigation to Referral Page
  const handleNavigate = () => {
    navigate(`${process.env.PUBLIC_URL}/recruiter/referral#data-table-shift`);
  };

  return (
    <li className="nav-item">
      <div
        className="d-flex  align-items-center"
        onClick={handleNavigate}
        style={{ cursor: "pointer" }}
      >
        <img width="28px" height="28px" className="me-1" src={point} alt="" />
        <h6 className="font-secondary mb-0 ">{styleTotalCoins(totalPoints)}</h6>
      </div>
    </li>
  );
};

export default TotalPoints;
